/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars *//* eslint-disable no-undef */

import { Dialog, DialogTitle, Grid, Typography } from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import React, { useState, useEffect } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import locale from 'date-fns/locale/pt-BR';
import TableDialog from './TableDialog';
import Button from '../../../../components/button/MyButton';
import ResumTable from './ResumTable';
import api from '../../../../service/axios/api';
import Loading from '../../../../components/loading/Loading';

export default function Resum({ setLoading, setMsg }) {
  const [dataCategory, setdataCategory] = useState([]);
  const [dataCompare, setdataCompare] = useState([]);
  const [openModalPayment, setOpenModalPayment] = useState(false);
  const [selected, setSelected] = useState([]);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [openDataDialog, setopenDataDialog] = useState(new Date());
  const [openDataDialogF, setopenDataDialogF] = useState(new Date());
  const [compareStart, setCompareStart] = useState(new Date());
  const [compareEnd, setCompareEnd] = useState(new Date());

  const [DialogLoading, setDialogLoading] = useState(false);
  const [tablekey, setkey] = useState([]);

  useEffect(() => {
    setMsg('Processando resumo por categoria...');
    setLoading(true);
    api.order
      .summaryResum(startDate.toISOString(), endDate.toISOString())
      .then(res => {
        setdataCategory(res.data.retorno.listCategory);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  const BuscaMetodos = () => {
    setMsg('Processando comparação por período...');
    setDialogLoading(true);
    api.order
      .summaryResum(
        openDataDialog.toISOString(),
        openDataDialogF.toISOString(),
        compareStart.toISOString(),
        compareEnd.toISOString(),
      )
      .then(res => {
        setdataCompare(res.data.retorno.listCompare);
        const controle = Object.keys(res.data.retorno.listCompare[0]);
        setkey(controle);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => setDialogLoading(false));
  };

  // useEffect(() => {
  //   BuscaMetodos()
  // }, [])

  const handleEdit = () => {
    setOpenModalPayment(true);
  };

  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '20px',
          marginBottom: '40px',
        }}
      >
        <h3>Resumo por categoria</h3>
        <div
          style={{
            marginTop: '8px',
            display: 'flex',
            gap: 5,
            alignItems: 'center',
          }}
        >
          <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
            <div style={{ display: 'flex', gap: '10px' }}>
              <div>
                <h6>Data início</h6>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  size="small"
                  format="dd/MM/yyyy"
                  maxDate={endDate} // Não deixa o início ser maior que o fim
                  value={startDate}
                  onChange={date => setStartDate(date)}
                />
              </div>
              <div>
                <h6>Data fim</h6>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  size="small"
                  format="dd/MM/yyyy"
                  minDate={startDate} // Não deixa o fim ser menor que o início
                  maxDate={new Date()}
                  value={endDate}
                  onChange={date => setEndDate(date)}
                />
              </div>
            </div>
          </MuiPickersUtilsProvider>
          <Button
            style={{ height: 45, marginTop: '20px' }}
            onClick={handleEdit}
            color="primary"
            variant="contained"
            label="Comparar Valores"
          />
        </div>
      </Grid>

      <Grid style={{ marginBottom: '20px', marginLeft: '10px', width: '100%' }}>
        <ResumTable
          docs={dataCategory}
          setDocs={setdataCategory}
          setSelected={setSelected}
          selected={selected}
        />
      </Grid>
      <Dialog
        onClose={() => setOpenModalPayment(false)}
        open={openModalPayment}
        fullWidth
        maxWidth="md"
      >
        <Loading open={DialogLoading} msg="Buscando relatório..." />
        <DialogTitle id="dialog-resum-title">
          <Grid
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '5px',
            }}
          >
            <Grid>Comparação de Períodos Personalizados</Grid>
          </Grid>
        </DialogTitle>
        <Grid container spacing={5} style={{ padding: '0 20px' }}>
          {/* Período A (Base) */}
          <Grid item xs={6}>
            <Typography variant="subtitle2" align="center">
              Período Base
            </Typography>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <KeyboardDatePicker
                    label="De"
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    size="small"
                    format="dd/MM/yyyy"
                    value={openDataDialog}
                    onChange={setopenDataDialog}
                    maxDate={openDataDialogF}
                  />
                </Grid>
                <Grid item xs={6}>
                  <KeyboardDatePicker
                    label="Até"
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    size="small"
                    format="dd/MM/yyyy"
                    value={openDataDialogF}
                    onChange={setopenDataDialogF}
                    minDate={openDataDialog}
                    maxDate={new Date()}
                  />
                </Grid>
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>

          {/* Período B (Comparação) */}
          <Grid item xs={6}>
            <Typography variant="subtitle2" align="center">
              Período Comparação
            </Typography>
            <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <KeyboardDatePicker
                    label="De"
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    size="small"
                    format="dd/MM/yyyy"
                    value={compareStart}
                    onChange={setCompareStart}
                    maxDate={compareEnd}
                  />
                </Grid>
                <Grid item xs={6}>
                  <KeyboardDatePicker
                    label="Até"
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    size="small"
                    format="dd/MM/yyyy"
                    value={compareEnd}
                    onChange={setCompareEnd}
                    minDate={compareStart}
                    maxDate={new Date()}
                  />
                </Grid>
              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <Grid container justify="center" style={{ margin: '20px 0' }}>
          <Button
            onClick={BuscaMetodos}
            color="primary"
            variant="contained"
            label="Comparar"
          />
        </Grid>

        <Grid style={{ margin: '20px' }}>
          <TableDialog
            style={{ size: '50%' }}
            docs={dataCompare}
            setDocs={setdataCompare}
            tablekey={tablekey}
            setSelected={setSelected}
            selected={selected}
          />
        </Grid>
      </Dialog>
    </>
  );
}
